// Словарь подпроекта 8, часть 8.2 «Старт работ по оплате»: «Ждёт оплаты» у этапов и задач. Подключается в `ru.ts`.

/** «Ждёт оплаты» в проекте и «Моих задачах» (ключи `projects.payment.*`). */
export const ruProjectsPayment = {
  waiting: 'Ждёт оплаты',
  waived: 'Начат без оплаты',
  invoice: 'счёт {number}',
  noInvoice: 'счёт ещё не выставлен',
  waive: 'Начать без оплаты',
  wait: 'Ждать оплату',
  waivedToast: 'Этап «{stage}» начат без оплаты',
  waitToast: 'Этап «{stage}» снова ждёт оплаты',
  reason: 'Оплата этапа',
  hint: {
    title: 'Ждёт оплаты',
    text: 'Этап ждёт оплаты долей графика подписанной заявки: доля «при подписании» открывает первый этап, доля «со стартом этапа» — свой этап. Пришла оплата — отметка снимается сама, руководитель и исполнители получают уведомление. Работу отметка не запрещает: руководитель может начать без оплаты',
    example: 'Предоплата 50 % по СЧ-2026-0012 оплачена — у задач «Дизайна» пропадает «Ждёт оплаты»',
  },
} as const;

/** Уведомления (в `projects.notifications`). */
export const ruProjectsPaymentNotifications = {
  stagePaidTitle: 'Оплата пришла — этап «{stage}» можно начинать',
  stagePaymentCancelledTitle: 'Оплата этапа «{stage}» отменена',
} as const;

/** Типы уведомлений (в `notifications`). */
export const ruProjectsPaymentNotificationTypes = {
  typeProjectsStagePaid: 'Оплата этапа пришла',
  typeProjectsStagePaidHint: 'Клиент оплатил долю графика — этап, который ждал оплаты, можно начинать',
  typeProjectsStagePaymentCancelled: 'Оплата этапа отменена',
  typeProjectsStagePaymentCancelledHint:
    'Руководителю: оплату, открывшую этап, удалили или счёт отозвали — этап снова ждёт оплаты',
} as const;

/** Ошибки (в `errors.projects`). */
export const ruProjectsPaymentErrors = {
  stage_not_waiting: 'Этап уже не ждёт оплаты',
} as const;

/** «История» проекта. */
export const ruProjectsPaymentAudit = {
  actions: {
    project: {
      stage_payment_changed: 'Изменилось условие оплаты этапа',
    },
  },
  fields: {
    stagePayment: 'Оплата этапа',
  },
} as const;
